<div class="mt-3" *ngIf="!loading && currentUsage">
  <!-- Current Billing Period -->
  <div class="bg-gray-50 rounded p-3 mb-2">
    <h3 class="text-xs font-semibold mb-1 text-gray-900" i18n>Trenutno obračunsko obdobje</h3>
    <p class="text-xs text-gray-600 mb-3">
      {{ formatDate(currentUsage.period_start) }} - {{ formatFullDate(currentUsage.period_end) }}
    </p>

    <!-- Usage Count -->
    <div class="mb-3">
      <div class="flex justify-between items-center">
        <span class="text-xs text-gray-700" i18n>Obdelana vozila</span>
        <span class="text-xs font-semibold text-gray-900">
          {{ currentUsage.units_used }}
        </span>
      </div>
    </div>

    <!-- Cost Estimate -->
    <div class="border-t border-gray-200 pt-3">
      <div class="flex justify-between items-center py-1 border-b border-gray-100"
           *ngIf="accountModulePackage.hasSubscription">
        <span class="text-xs text-gray-700" i18n>Mesečna naročnina</span>
        <span class="text-xs font-semibold text-gray-900">
          €{{ formatPrice(accountModulePackage.subscriptionPrice) }}
        </span>
      </div>

      <div class="flex justify-between items-center py-1 border-b border-gray-100"
           *ngIf="currentUsage.billable_units > 0">
        <span class="text-xs text-gray-700">
          <span i18n>Dodatna vozila</span>
          ({{ currentUsage.billable_units }} × €{{ formatPrice(currentUsage.price_per_unit) }})
        </span>
        <span class="text-xs font-semibold text-gray-900">
          €{{ formatPrice(currentUsage.estimated_charge) }}
        </span>
      </div>

      <div class="flex justify-between items-center pt-2"
           *ngIf="currentUsage.estimated_charge > 0 || accountModulePackage.hasSubscription">
        <span class="text-xs font-semibold text-gray-900" i18n>Ocenjeni skupaj</span>
        <span class="text-sm font-bold text-blue-600">
          €{{ formatPrice(getTotalEstimated()) }}
        </span>
      </div>

      <div class="text-center py-2"
           *ngIf="!accountModulePackage.hasSubscription && currentUsage.estimated_charge === 0">
        <p class="text-xs text-green-600 font-medium" i18n>Še ni stroškov ta mesec</p>
      </div>
    </div>
  </div>
</div>

<div class="text-center py-6" *ngIf="loading">
  <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
</div>
